import { useEffect } from 'react'

interface PulsingExpandButtonProps {
  label: string
  count: number
  countLabel: string
  countLabelPlural: string
  isExpanded: boolean
  onToggle: () => void
}

export function PulsingExpandButton({
  label,
  count,
  countLabel,
  countLabelPlural,
  isExpanded,
  onToggle,
}: PulsingExpandButtonProps) {
  // Add pulsing animation style
  useEffect(() => {
    const styleId = 'pulsing-expand-button-animation'
    const existingStyle = document.getElementById(styleId)
    if (existingStyle) {
      existingStyle.remove()
    }
    
    const style = document.createElement('style')
    style.id = styleId
    style.textContent = `
      @keyframes pulsingExpandButtonPulse {
        0%, 100% {
          opacity: 0.6;
        }
        50% {
          opacity: 0.9;
        }
      }
      .pulsing-expand-button-pulse {
        animation: pulsingExpandButtonPulse 2s ease-in-out infinite;
      }
    `
    document.head.appendChild(style)
    
    return () => {
      const styleToRemove = document.getElementById(styleId)
      if (styleToRemove) {
        styleToRemove.remove()
      }
    }
  }, [])

  return (
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-center gap-2 py-3 transition-all hover:opacity-70 active:opacity-50"
    >
      <span 
        className={`text-sm ${!isExpanded ? 'pulsing-expand-button-pulse' : ''}`}
        style={{ opacity: isExpanded ? 0.7 : undefined }}
      >
        {label}
      </span>
      <span 
        className={`text-xs ${!isExpanded ? 'pulsing-expand-button-pulse' : ''}`}
        style={{ opacity: isExpanded ? 0.5 : undefined }}
      >
        ({count} {count === 1 ? countLabel : countLabelPlural})
      </span>
      <span 
        className="text-sm transition-transform duration-200"
        style={{ 
          transform: isExpanded ? 'rotate(90deg)' : 'rotate(-90deg)',
          opacity: isExpanded ? 0.5 : undefined,
        }}
      >
        →
      </span>
    </button>
  )
}
